/**
 * Pick random element Исправить
 * @param {Array} options - array of all variants
 * @param {Array} correct - array of all correct variants
 * @param {String} type - type of current minigame
 * @param {String, Array} indices - choosen variant or array of indexes of choosen variants
 * @returns current state of the minigame.
 */

export default function ({ options, correct, type }, indices){
	return (indices.length === correct.length && (indices.every(i => correct.indexOf(i) !== -1)));
}